import { render, staticRenderFns } from "./connet-group.vue?vue&type=template&id=fb7fd8d6&lang=pug&"
import script from "./connet-group.vue?vue&type=script&lang=js&"
export * from "./connet-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports